module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buttons":{"add":{"address":"Add","paye":"Add new","dependants":"Add","default":"Add"}},"labels":{"noneOfTheAbove":"None of the above","noneOfThese":"None of these","or":"or"},"placeholders":{"paye":"PAYE reference number"}}}')
  delete Component.options._Ctor
}
